import { leagueFormatMap, sportLeagueMap } from "./CONSTANTS.js";
import React from "react";

const SharedSettings = (props) => {

    const settingsData = props.settingsData;


      return (
        <span>


            <div>
                <br></br> Sport: {sportLeagueMap[settingsData.sportId]}
                <br></br> Timeframe: {settingsData.timeframe}
                <br></br> Format: {leagueFormatMap[settingsData.format]}
                <br></br><br></br>

                {settingsData.format===0 &&
                    <div> <b>Portfolio Format Settings:</b>
                        <br></br>Starting Budget: ${settingsData.budget}
                        <br></br>Transaction Cost: {settingsData.transactionType}
                        <br></br>Shorting: {settingsData.shorting}
                        <br></br> In-Season Trading: {settingsData.inseason}
                    </div>
                }
                {settingsData.format===1 &&
                    <div> <b>Roster Format Settings:</b>
                        <br></br>Playoff Multipliers Active: {settingsData.multipliers}
                        <br></br>Restricted shares per {sportLeagueMap[settingsData.sportId]} Team: {settingsData.maxSharesPerTeam}
                        <br></br>In-Season Roster Changes: {settingsData.inseason}
                        <br></br>Roster:
                        {settingsData.sportId===1 && <span>
                        <br></br>    QB:   {settingsData.rosterData.get(2)}
                        <br></br>    RB:   {settingsData.rosterData.get(3)}
                        <br></br>    WR:   {settingsData.rosterData.get(4)}
                        <br></br>    TE:   {settingsData.rosterData.get(5)}
                        <br></br>    K:    {settingsData.rosterData.get(6)}
                        <br></br>    TEAM: {settingsData.rosterData.get(1)}
                        <br></br>
                        <br></br>Scoring:
                        <br></br>    Yards per Passing Point: 25
                        <br></br>    Points per Passing TD: 4
                        <br></br>    Points per Interception: -2
                        <br></br>    Yards per Rushing Point: 8
                        <br></br>    Points per Rushing TD: 6
                        <br></br>    Points per Reception: 1
                        <br></br>    Yards per Recieving Point: 10
                        <br></br>    Points per Recieving TD: 6
                        <br></br>    Points per Fumble Lost: -2
                        <br></br>    Points per Extra Point Made: 1
                        <br></br>    Points per 39 Yards or Fewer Field Goal Made: 3
                        <br></br>    Points per Field Goal Made 40-49 Yards: 4
                        <br></br>    Points per Field Goal Made 50-59 Yards: 5
                        <br></br>    Points per Field Goal Made 50-59 Yards: 6
                        <br></br>    Points per Extra Point or Field Goal under 40 Yards Missed: -1
                        <br></br>    TEAM Points per Win: 10
                        </span>}
                        {settingsData.sportId===6 && <span>
                        <br></br>    TEAM: 1 Team Per Seed
                        <br></br>
                        <br></br>Scoring:
                        <br></br>    2 Points for first round win. Points double every successive round.
                        </span>}
                    </div>
                }


            </div>

        </span>
      )

}


export default SharedSettings;